<script>
import { mapState, mapMutations } from "vuex";

export default {
  computed: mapState(["toasts"]),
  methods: mapMutations(["shiftToasts"]),
  watch: {
    toasts: function () {
      // Whenever "toasts" changes in the state, then do the following

      // For each toast currently in the state
      for (let toast of this.toasts) {
        // Push the first toast in the toasts array to the UI using Bootstrap Vue
        this.$bvToast.toast(toast.message, {
          title: toast.title,
          variant: toast.variant,
        });

        // Remove one toast from the beginning of the toasts array in state
        this.shiftToasts();
      }
    },
  },
};
</script>

<template>
  <!--  empty - doesn't need any DOM since it's all managed by Bootstrap Vue -->
  <div class="Toasts"></div>
</template>
